import styled from "styled-components";
import BatmaidLogo from "@batmaid/design-tokens/logo";

import { info as navBarInfo } from "@components/Navigation/NavBar";

export const LogoContainer = styled.div`
  a {
    display: inline-block;
  }
`;

export const Logo = styled(BatmaidLogo.Blue)`
  height: ${navBarInfo.innerHeight.default}px;
  pointer-events: none;

  ${props => props.theme.breakpointsV2.smallTablet} {
    height: ${navBarInfo.innerHeight.smallTablet}px;
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    height: ${navBarInfo.innerHeight.smallDesktop}px;
  }
`;

export const ActionsGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${props => props.theme.spacing.spacing_24};
  grid-column: 3;

  ${props => props.theme.breakpointsV2.smallDesktop} {
    align-items: flex-end;
    gap: ${props => props.theme.spacing.spacing_32};
  }
`;

export const MainNav = styled.div`
  display: none;

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: block;
  }
`;
